function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { TextField } from '@doordash/component-fields';
import { Text } from '@doordash/design-language';
import { BodyCell, TextFieldWrapper } from './styles';

var EditableCell = function EditableCell(_ref) {
  var onCellEdit = _ref.onCellEdit,
      originalValue = _ref.originalValue,
      originalRowInformation = _ref.originalRowInformation,
      rowIndex = _ref.rowIndex,
      columnId = _ref.columnId,
      cellProps = _ref.cellProps,
      customStyles = _ref.customStyles,
      bodyTextProps = _ref.bodyTextProps;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isEditing = _React$useState2[0],
      setIsEditing = _React$useState2[1];

  var _React$useState3 = React.useState(originalValue),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      currentCellVal = _React$useState4[0],
      setCurrentCellVal = _React$useState4[1];

  return /*#__PURE__*/React.createElement(BodyCell, _extends({
    noPadding: isEditing,
    customStyles: _objectSpread({}, customStyles)
  }, cellProps), isEditing ? /*#__PURE__*/React.createElement(TextField, {
    label: "Editing cell value",
    isLabelHidden: true,
    autoFocus: true,
    size: TextField.Sizes.Small,
    value: currentCellVal,
    onChange: function onChange(val) {
      return setCurrentCellVal(val);
    },
    onBlur: function onBlur() {
      setCurrentCellVal(originalValue);
      setIsEditing(!isEditing);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Escape') {
        setCurrentCellVal(originalValue);
        setIsEditing(false);
      }

      if (event.key === 'Enter') {
        if (onCellEdit) {
          onCellEdit({
            originalRow: originalRowInformation,
            originalVal: originalValue,
            updatedVal: currentCellVal,
            rowIndex: rowIndex,
            columnId: columnId
          });
        }

        setIsEditing(false);
      }

      if (event.key === 'Tab') {
        if (onCellEdit) {
          onCellEdit({
            originalRow: originalRowInformation,
            originalVal: originalValue,
            updatedVal: currentCellVal,
            rowIndex: rowIndex,
            columnId: columnId
          });
        }

        setIsEditing(false);
      }
    }
  }) : /*#__PURE__*/React.createElement(TextFieldWrapper, {
    tabIndex: 0,
    onClick: function onClick() {
      return setIsEditing(true);
    },
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'Enter') {
        setIsEditing(true);
      }
    }
  }, /*#__PURE__*/React.createElement(Text, _extends({
    styles: Text.Styles.TableMediumBody
  }, bodyTextProps), currentCellVal)));
};

export default EditableCell;